var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app_box"},[_c('Htitle'),_c('TopNavbar'),(this.screenWidth > 1024)?_c('Banner'):_vm._e(),_c('PageLayout'),_c('BackToTop'),_c('Passenger'),_c('Htitle')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }